import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const NdsSverkaPanel = styled.div(props => ({
    padding: "8px 0 8px 0",
    borderBottom: theme(props).border.solid,
    overflow: "hidden",
    width: "100%",
    boxSizing: "border-box",
}));
